import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Modal} from "../../../02-Molecules/Modal/Modal";
import {Section} from "../../../02-Molecules/Section/Section";

/**
 * StepThree component
 */
export const StepThree = ({accountHolder, accountNumber, accountSortCode, guaranteeText, giftaidRate, onBack, recapText, values}) => {
  const [modalIsOpen, modalIsOpenSet] = useState(false)

  /**
   * Handle the modal open / close action
   */
  const handleFaqModalShowHide = () => modalIsOpenSet(!modalIsOpen)

  return (
    <div>
      <div className={'b-form-row'}>
        Account holder name<br />
        <strong>{accountHolder}</strong>
      </div>

      <div className={'b-form-row'}>
        Account number<br />
        <strong>{accountNumber}</strong>
      </div>

      <div className={'b-form-row'}>
        Account sort code<br />
        <strong>{accountSortCode}</strong>
      </div>

      <div className={'b-form-row'}>
        <button className={'b-button-text-blue'} onClick={() => onBack(1)}>Amend details</button>
      </div>

      <div className={'o-section-bank-details__recap'}>
        <div className={'b-form-row'}>
          <p>You are setting up a monthly Direct Debit of <strong>£{parseFloat(values.payment_amount).toFixed(2).replace('.00', '')}</strong></p>

          {values.gift_aid &&
            <p>Plus a Gift Aid donation of <strong>£{((parseFloat(values.payment_amount) * giftaidRate) - parseFloat(values.payment_amount)).toFixed(2).replace('.00', '')}</strong></p>
          }

          <p>This payment will appear on your statement as <strong>Wood Green Animal Shelter</strong></p>
        </div>

        <div className={'b-form-row'}>
          <button className={'b-button-text-blue'} onClick={() => handleFaqModalShowHide()} >Read the direct debit guarantee</button>
        </div>

        <div dangerouslySetInnerHTML={{ __html: recapText }} />
      </div>

      <Modal modalShow={modalIsOpen} handleModalShow={handleFaqModalShowHide}>
        <Section>
          <div dangerouslySetInnerHTML={{ __html: guaranteeText }} />
        </Section>
      </Modal>
    </div>
  )
}

/**
 * StepOne PropType
 */
StepThree.propTypes = {
  accountHolder  : PropTypes.string,
  accountNumber  : PropTypes.string,
  accountSortCode: PropTypes.string,
  guaranteeText: PropTypes.string,
  giftaidRate    : PropTypes.number,
  recapText      : PropTypes.string,
  values          : PropTypes.shape({
    gift_aid      : PropTypes.string,
    payment_amount: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
  })
}
